module.exports = __webpack_public_path__ + "static/ibm-cb1551637a2a009f4ed14185bd2b1bf2.svg";